var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 12.2087C7.80387 11.6685 7.06604 11.3333 6.24992 11.3333C4.63909 11.3333 3.33325 12.6391 3.33325 14.25C3.33325 15.8608 4.63909 17.1666 6.24992 17.1666C7.86075 17.1666 9.16659 15.8608 9.16659 14.25C9.16659 13.4553 8.84875 12.7348 8.33325 12.2087ZM8.33325 12.2087L12.5262 8.01576M16.7087 7.16664L15.6313 6.08923C15.3058 5.76379 14.7782 5.76379 14.4528 6.08923L12.5262 8.01576M12.5262 8.01576L14.1666 9.65612",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8ec144e0ab970a0047f37d4ff3e239c6.svg";
export { ForwardRef as ReactComponent };